import React from 'react';
import { Col, Container, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import classNames from 'classnames';
import ScrollParallax from 'rc-scroll-anim/lib/ScrollParallax';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

interface BenefitListItemProps {}

const BenefitListItem: React.FC<BenefitListItemProps> = props => {
  const { children } = props;

  const itemClassName = classNames('border-0', 'd-flex', 'flex-row', 'px-0');

  return (
    <ListGroupItem className={itemClassName}>
      <FontAwesomeIcon
        icon={faCheckCircle}
        size="lg"
        className={classNames('mr-2', 'text-green-shade-03')}
      />
      <div>{children}</div>
    </ListGroupItem>
  );
};

export const LockTypes: React.FC = props => {
  const imgClassName = classNames('rounded-lg', 'mx-auto', 'mx-md-0', 'shadow');

  return (
    <StaticQuery
      query={graphql`
        query {
          mechanicLock: file(
            name: { regex: "/mechanic-lock/" }
            extension: { eq: "jpg" }
          ) {
            childImageSharp {
              fluid(maxHeight: 620, maxWidth: 500) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          smartHomeLock: file(
            name: { regex: "/smart-home-lock/" }
            extension: { eq: "jpg" }
          ) {
            childImageSharp {
              fluid(maxHeight: 620, maxWidth: 500) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={data => (
        <Container className="my-8">
          <Row className="align-items-center">
            <Col md={6}>
              <Img
                fluid={data.mechanicLock.childImageSharp.fluid}
                className={imgClassName}
              />
            </Col>
            <Col xs={12} md={6} className="py-5 mb-4 mb-md-0">
              <h2>Der Klassiker unter den Zutrittssystemen.</h2>
              <p className="lead">
                Greifen Sie mit einem <strong>mechanischen</strong>{' '}
                Zutrittssystem zum altbewährten Klassiker unter den Systemen für
                Zutrittskontrolle.
              </p>
            </Col>
          </Row>
          <Row className="align-items-center">
            <ScrollParallax
              animation={{
                marginTop: '-3.0rem',
                playScale: [0.0, 1.0],
              }}
              className="col order-md-2"
            >
              <Img
                fluid={data.smartHomeLock.childImageSharp.fluid}
                className={imgClassName}
              />
            </ScrollParallax>
            <Col xs={12} md={6} className="py-5">
              <h2>Die Zukunft der Zutrittskontrolle.</h2>
              <p className="lead">
                Durch die Entwicklung sogenannter Funkzylinder ist der Umstieg
                auf eine <strong>elektronische</strong> Zutrittskontrolle auch
                für Kleinbetriebe und Privatpersonen sehr einfach und
                kostengünstig.
              </p>

              <ListGroup flush>
                <BenefitListItem>
                  Einfacher Umstieg durch Zylindertausch
                </BenefitListItem>
                <BenefitListItem>
                  Geeignet für Kleinbetriebe und Privatpersonen
                </BenefitListItem>
                <BenefitListItem>
                  Geringer Stückpreis per Schlüssel
                </BenefitListItem>
                <BenefitListItem>
                  Kein Zylindertausch notwendig bei Verlust
                </BenefitListItem>
                <BenefitListItem>
                  Standalone oder vernetzte Systeme
                </BenefitListItem>
              </ListGroup>
            </Col>
          </Row>
        </Container>
      )}
    />
  );
};
